﻿import { CheckTreeEditor, SlickFormatting } from "@serenity-is/corelib";
import type { Column } from "@serenity-is/sleekgrid";

const orgGetColumns = CheckTreeEditor.prototype["createColumns"];

if (orgGetColumns) {
    CheckTreeEditor.prototype["createColumns"] = function () {
        const columns: Column[] = [];
        columns.push({
            field: 'text',
            name: 'Record',
            width: 80,
            format: SlickFormatting.treeToggle(() => this.view, x => x.id, ctx => {
                const item = ctx.item;
                if (item.hideCheckBox) {
                    return this.getItemText(ctx);
                }
                const threeState = this.isThreeStateHierarchy();
                return <>
                    <span
                        class={["check-box", item.isSelected && (threeState && !item.isAllDescendantsSelected ? "partial" : "checked"), this._readOnly && "readonly"]}></span>
                    {this.getItemText(ctx)}
                </>;
            })
        });
        return columns;
    };
}
